import { useBoolean } from '@chakra-ui/react';
import React, { useState, useContext } from 'react';
import { useParams } from 'react-router-dom';
import ChartAccuracyComponents from '../../../../components/dashboard_components/ChartAccuracyComponents';
import { CUSTOM } from '../../../../constants/constants';
import departmentDashboardRepository from '../../../../repositories/DepartmentRepository';
import { dateFormat, setFilters } from '../../../../utils/common.utils';
import { DepartmentContext } from '../../../../providers/DepartmentProvider';

function DChartAccuracy({
  defaultStartDate,
  defaultEndDate,
  startDate,
  endDate,
  filter,
}) {
  const departmentContext = useContext(DepartmentContext);
  const { departmentId } = useParams();
  const [isFetching, ifState] = useBoolean(false);
  const [cqScore, setCqScore] = useState(null);
  const selectedDates = JSON.parse(
    window.localStorage.getItem('customDateFilter')
  );

  const setCustomDates = filterParams => {
    for (const prop in selectedDates) {
      filterParams[prop] = dateFormat(
        new Date(selectedDates[prop]),
        'yyyy-MM-dd'
      );
    }
  };

  const fetchCqScore = async () => {
    try {
      ifState.on();
      const filterParams = {};
      filterParams.filter = filter.toLowerCase();
      if (filter === CUSTOM.toLowerCase()) {
        setCustomDates(filterParams);
        // setFilters(
        //   filterParams,
        //   dateFormat(defaultStartDate, 'yyyy-MM-dd'),
        //   dateFormat(defaultEndDate, 'yyyy-MM-dd'),
        //   dateFormat(startDate, 'yyyy-MM-dd'),
        //   dateFormat(endDate, 'yyyy-MM-dd')
        // );
        delete filterParams.filter;
      }
      filterParams.department_id = departmentId;

      const response = await departmentDashboardRepository.getDepartmentCqScore(
        filterParams
      );
      setCqScore(response);
      departmentContext.setCQScore(response);
      return response;
    } catch (error) {
      setCqScore(null);
    } finally {
      ifState.off();
    }
  };

  React.useEffect(() => {
    fetchCqScore();
    // eslint-disable-next-line
  }, [defaultStartDate, defaultEndDate, filter]);

  const uiStartDate = dateFormat(defaultStartDate, 'MM/dd/yyyy');
  const uiEndDate = dateFormat(defaultEndDate, 'MM/dd/yyyy');

  return (
    <ChartAccuracyComponents
      isFetching={isFetching}
      cq_score={cqScore}
      defaultStartDate={uiStartDate}
      defaultEndDate={uiEndDate}
      filter={filter}
    />
  );
}

export default DChartAccuracy;
